const roles = {
  firestorePath: '/roles',
  firestoreRefType: 'collection',
  moduleName: 'roles',
  statePropName: 'roles',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
    },
  },

  state: {
    roles: null,
  },
  getters: {
    getRoles: (state) => {
      return _.toArray(state.roles);
    },
    getRole: (state) => (id) => {
      return state.roles[id] ? state.roles[id] : null
    },
  },
  mutations: {},
  actions: {},
}

export default roles